/* eslint-disable no-console */

import { isIE } from "../components/Notifier";

/**
 * Log only in IE
 * @param {string} message message to log
 * @param {('error'|'info'|'exception'|'log')} [severity='log'] Severity. For default is Info.
 */
export const log = (message, severity = "log") => {
  if (isIE() || process.env.NODE_ENV === "production") {
    return;
  }

  switch (severity) {
    case "error": {
      return console.error(message);
    }
    case "info": {
      return console.info(message);
    }
    case "exception": {
      return console.exception(message);
    }
    case "log": {
      return console.log(message);
    }
    default: {
      return console.log(message);
    }
  }
};
